import { useAuthentication } from 'src/features/authentication/context';
import { Protected } from 'src/features/protected-route/components';
import { AppLayout } from 'src/layouts';
import AccountBillingInformationPage from 'src/features/account-billing-information/pages/AccountBillingInformationPage';
import { ACCOUNT_ISSUE_PATH, LOGIN_PATH, ACCOUNT_BILLING_INFORMATION_HEADER } from '../../config';
import {
  NAV_ITEMS_HEADER_SITES_MANAGEMENT,
  getNavItemsHeaderSiutesManagementSAAndAA,
} from 'src/features';
import { ElementProps } from '../../types/element';
import { LoadingElement } from '../LoadingElement';
import { useCallback, useMemo } from 'react';
import { AccessRoles } from 'src/features/user-account-details/types';

export const AccountBillingInformationElement = ({ isSuperAdmin }: ElementProps) => {
  const { loggedIn, customerId, user, isBillingAdminForCustomer, getCurrentRole } =
    useAuthentication();

  const isAccountAdmin = getCurrentRole(customerId.value, null) === AccessRoles.ACCOUNT_ADMIN;

  const canAccess = isSuperAdmin || isBillingAdminForCustomer(customerId.value ?? '');

  const getUniqueRedirectPath = useCallback(() => {
    if (!loggedIn.value) return LOGIN_PATH;

    if (!canAccess) {
      return `${ACCOUNT_ISSUE_PATH}?reason=Access Denied`;
    }

    return null;
  }, [loggedIn.value, canAccess]);

  const element = useMemo(
    () => (
      <Protected
        isAuthenticated={loggedIn.value}
        isAuthorized={canAccess}
        uniqueRedirectPath={getUniqueRedirectPath()}
      >
        <AppLayout
          headerTitle={ACCOUNT_BILLING_INFORMATION_HEADER}
          headerNavItems={
            isSuperAdmin || isAccountAdmin
              ? getNavItemsHeaderSiutesManagementSAAndAA(user, isSuperAdmin)
              : NAV_ITEMS_HEADER_SITES_MANAGEMENT
          }
        >
          <AccountBillingInformationPage />
        </AppLayout>
      </Protected>
    ),
    [loggedIn.value, canAccess, getUniqueRedirectPath, user, isSuperAdmin, isAccountAdmin]
  );

  if (!loggedIn.loaded || !customerId.loaded) {
    return <LoadingElement />;
  }

  return element;
};
